import PropTypes from "prop-types";

// Components
import SimpleIconButton from "@Layouts/components/Buttons/SimpleIconButton";

// Icons
import { ReactComponent as ArithmeticIcon } from "@/assets/icons/settings/arithmetic.svg";

function Arithmetic(props) {
	const { apiRef, disabled, onArithmeticAction } = props;
	const onClickHandler = () => {
		const selectedIds = apiRef.current.getSelectedRows();
		onArithmeticAction?.([...selectedIds.values()].map((item) => item.id || item._id));
	};
	return <SimpleIconButton onClick={onClickHandler} icon={<ArithmeticIcon width={17} />} disabled={disabled} />;
}

Arithmetic.propTypes = {
	apiRef: PropTypes.shape({
		current: PropTypes.object,
	}),
	disabled: PropTypes.bool,
	onArithmeticAction: PropTypes.func,
};

export default Arithmetic;
